import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  get_dp246mt9ygxfnpl as get_dp,
  get_dp28ag147e4p5cz as get_dp_0,
  minus1paei8txflgx9 as minus,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  timesx4ey3un7ihw1 as times,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_expandButtonTheme1dpdnzsv2lxs8 as get_expandButtonTheme,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
} from '../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import {
  SectionSemantic_getInstance27qbv8tkwzf0w as SectionSemantic_getInstance,
  get_lightSection4cpu8okr0w14 as get_lightSection,
} from '../../../../theming/sections.mjs';
import {
  dynamicThemexp3sdnaolntz as dynamicTheme,
  get_compact3lsezez8nz8b6 as get_compact,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  align1ejncrrer3meh as align,
  shownWhenxgf1ujy6rmvr as shownWhen,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_atStart2tgdnaxgj04ln as get_atStart,
  forEach37zw770vd3h4l as forEach,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atTopStart2sqdmdfleu6ji as get_atTopStart,
  get_atEnd1cw5d2zgug26 as get_atEnd,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import {
  isUnread2wfj6ps7oiv9h as isUnread,
  isUnread2u0ehyt0ioouz as isUnread_0,
} from '../../../../../extensions/HasReadBy.ext.mjs';
import { unreadIconWhen1430ixd91bo9h as unreadIconWhen } from '../../../iconShortcuts.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  expandIcon1as9er6lyg7in as expandIcon,
  expandAndDelayMarkAsReadAction7idih42oelvd as expandAndDelayMarkAsReadAction,
} from '../../../expansion.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
  smallBody2trfy14zwtona as smallBody,
} from '../../../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
} from '../../../space.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  newTasksAllowed26ihc5f4iqgon as newTasksAllowed,
  newTasksAllowed2g7c6d9oaegnt as newTasksAllowed_0,
  isProjectLocked21m24mmy2in1h as isProjectLocked,
  newRequiredTasksAllowedvxh24ivnbst1 as newRequiredTasksAllowed,
} from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance } from '../../../../screens/common/ProjectView.mjs';
import {
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  resize3py5p2yrjp6p7 as resize,
  Action1a4ymn5nx79hk as Action,
} from '../../../../../utils/utils.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_dialogStackleaqvayyucjw as get_dialogStack,
} from '../../../nav/crowpay.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../theming/separators.mjs';
import {
  NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance,
  PunchFieldSemantic_getInstance17evc960lld2j as PunchFieldSemantic_getInstance,
} from '../../../../theming/appTheme.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  plus20p0vtfmu0596 as plus,
  minus1djrl64vbav3y as minus_0,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance_1 } from '../../../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../../../utils/JumpTo.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  forEachMaybeReorderableDestroying35lnn8f9ey87k as forEachMaybeReorderableDestroying,
  reorderts8zja415q79 as reorder,
} from '../../../reordering.mjs';
import {
  interceptWrite2xi6g5kl52xuu as interceptWrite,
  modify3tvoxz8jo60p8 as modify,
} from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  get_dragHandlemufcu3tsewag as get_dragHandle,
  get_trash3qsdn4kaynjmu as get_trash,
} from '../../../../../icons.mjs';
import { DragShadow11keb9piinnfw as DragShadow } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/DragData.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import {
  Companion_getInstance1350ksylxva5s as Companion_getInstance_2,
  plus354lvypr4cqa1 as plus_0,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { PunchListItem1wbu5dz9rlo4k as PunchListItem } from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_content1vw4q43mal60r as get_content,
  get_requiredy5h1ix9e5mkz as get_required,
} from '../../../../../../../../crowpay-shared/com/crowpay/PunchListItemFields.mjs';
import { lensPath10aseksl728gf as lensPath } from '../../../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { assertNotBlank1cpq7aqdam42n as assertNotBlank } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { FormattedTextInput3hltc3nesrzjq as FormattedTextInput } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/FormattedTextInput.commonHtml.mjs';
import { take9j4462mea726 as take } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { Movepj4bxmsunu5w as Move } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/forEachReorderable.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../../../dialogs/GenericConfirmationDialog.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_rowHeight() {
  _init_properties_renderPunchlists_kt__f3fhf();
  return rowHeight;
}
var rowHeight;
function get_rowSpacing() {
  _init_properties_renderPunchlists_kt__f3fhf();
  return rowSpacing;
}
var rowSpacing;
var checkboxSize;
function renderPunchListRow(_this__u8e3s4, title, expanded, project, items, lineItem, allowReorder, lens, rowHeight, buttonText, setTargets) {
  expanded = expanded === VOID ? Signal().hak(false) : expanded;
  allowReorder = allowReorder === VOID ? true : allowReorder;
  rowHeight = rowHeight === VOID ? null : rowHeight;
  buttonText = buttonText === VOID ? '+ Work Task' : buttonText;
  setTargets = setTargets === VOID ? true : setTargets;
  _init_properties_renderPunchlists_kt__f3fhf();
  var newItems = Signal().hak(emptyList());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_px(0));
  var tmp = rowHeight;
  if ((tmp == null ? null : new (Dimension())(tmp)) == null)
    null;
  else {
    var tmp_0 = rowHeight;
    // Inline function 'kotlin.let' call
    var it = (tmp_0 == null ? null : new (Dimension())(tmp_0)).yb1_1;
    sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, VOID, it);
  }
  var tmp_1 = get_expandButtonTheme(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.gba(get_AppDimensions().rg2_1);
  dynamicTheme(view_0, ($this$dynamicTheme) => $this$dynamicTheme.daj(expanded) ? SectionSemantic_getInstance() : null);
  var tmp_2 = align(view_0, Align_Start_getInstance(), Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.bb9(get_AppDimensions().og2_1);
  get_centered(view_1);
  unreadIconWhen(view_1, ($this$unreadIconWhen) => isUnread($this$unreadIconWhen.daj(items), $this$unreadIconWhen.daj(get_session()).gfv_1));
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  Companion_getInstance_0();
  view_1.lbb(get_centered(view_1), expandIcon(view_1, expanded));
  var tmp_3 = get_centered(view_1);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var tmp$ret$3 = $this$reactiveScope.daj(title);
    this_0.set(tmp$ret$3);
    return Unit_instance;
  });
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_3, view_2);
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_2, view_1);
  view_0.obg(expandAndDelayMarkAsReadAction(expanded, renderPunchListRow$slambda_0(items)));
  view.hbb(p_0, view_0);
  view.lbb(tmp_1, view_0);
  var tmp_6 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(expanded));
  // Inline function 'com.crowpay.views.components.indentIfWideCol' call
  var indent = Indent_Section_getInstance();
  var tmp_7;
  if (get_viewIsWide(view)) {
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var tmp2 = indent.agr_1;
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var afterSpace = indent.bgr_1;
    var tmp_8 = get_unpadded(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_3 = view.ebb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
    view.gbb(p_3, view_3);
    var tmp_9;
    var tmp_10 = null;
    if (!((tmp_10 == null ? null : new (Dimension())(tmp_10)) == null)) {
      tmp_9 = sizeConstraints(view_3, VOID, VOID, VOID, VOID, VOID, null);
    } else {
      tmp_9 = Companion_getInstance_0();
    }
    var tmp_11 = view_3.kbb(tmp_9, indented(view_3, tmp2, afterSpace));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.ebb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.gbb(p_4, view_4);
    view_4.zbm(true);
    view_4.bb9(get_rem(1));
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (Space())(view_4.pc());
    var tmp0_elvis_lhs_5 = view_4.ebb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
    view_4.gbb(p_5, view_5);
    view_4.hbb(p_5, view_5);
    var tmp_12 = view_4.kbb(get_atStart(view_4), get_tertiaryButton(view_4));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (Button())(view_4.pc());
    var tmp0_elvis_lhs_6 = view_4.ebb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
    view_4.gbb(p_6, view_6);
    view_6.gba(get_rem_0(0.3));
    shownDefaultFalse(view_6, ($this$shownDefaultFalse) => {
      var tmp;
      if (lens.equals(ProjectLens_Contractor_getInstance()) && newTasksAllowed_0($this$shownDefaultFalse.daj(project).u7b_1)) {
        var tmp0_safe_receiver = lineItem;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$shownDefaultFalse.daj(tmp0_safe_receiver);
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.mfy();
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : newTasksAllowed(tmp2_safe_receiver);
        tmp = tmp3_elvis_lhs == null ? true : tmp3_elvis_lhs;
      } else {
        tmp = false;
      }
      return tmp;
    });
    var tmp_13 = KMutableProperty0();
    var tmp_14 = Button$_get_enabled_$ref_61t7nx(view_6);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('enabled', 0, tmp_13, tmp_14, Button$_set_enabled_$ref_o8kynz(view_6));
    reactiveScope(view_6, ($this$reactiveScope) => {
      var tmp$ret$20 = !isProjectLocked($this$reactiveScope.daj(project).u7b_1);
      this_1.set(tmp$ret$20);
      return Unit_instance;
    });
    specCenteredText(view_6, buttonText);
    onClick(view_6, VOID, VOID, renderPunchListRow$slambda_2(newItems, project, lineItem));
    view_4.hbb(p_6, view_6);
    view_4.lbb(tmp_12, view_6);
    punchListCol(view_4, items, newItems, lineItem, lens, allowReorder, setTargets, buttonText, expanded);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (Space())(view_4.pc());
    var tmp0_elvis_lhs_7 = view_4.ebb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_4 : tmp0_elvis_lhs_7;
    view_4.gbb(p_7, view_7);
    view_4.hbb(p_7, view_7);
    view_3.hbb(p_4, view_4);
    view_3.lbb(tmp_11, view_4);
    view.hbb(p_3, view_3);
    tmp_7 = view.lbb(tmp_8, view_3);
  } else {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_8 = view.ebb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view : tmp0_elvis_lhs_8;
    view.gbb(p_8, view_8);
    view_8.zbm(true);
    view_8.bb9(get_rem(1));
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (Space())(view_8.pc());
    var tmp0_elvis_lhs_9 = view_8.ebb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
    view_8.gbb(p_9, view_9);
    view_8.hbb(p_9, view_9);
    var tmp_15 = view_8.kbb(get_atStart(view_8), get_tertiaryButton(view_8));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_10 = new (Button())(view_8.pc());
    var tmp0_elvis_lhs_10 = view_8.ebb_1;
    var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
    view_8.gbb(p_10, view_10);
    view_10.gba(get_rem_0(0.3));
    shownDefaultFalse(view_10, ($this$shownDefaultFalse) => {
      var tmp;
      if (lens.equals(ProjectLens_Contractor_getInstance()) && newTasksAllowed_0($this$shownDefaultFalse.daj(project).u7b_1)) {
        var tmp0_safe_receiver = lineItem;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$shownDefaultFalse.daj(tmp0_safe_receiver);
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.mfy();
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : newTasksAllowed(tmp2_safe_receiver);
        tmp = tmp3_elvis_lhs == null ? true : tmp3_elvis_lhs;
      } else {
        tmp = false;
      }
      return tmp;
    });
    var tmp_16 = KMutableProperty0();
    var tmp_17 = Button$_get_enabled_$ref_61t7nx_0(view_10);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('enabled', 0, tmp_16, tmp_17, Button$_set_enabled_$ref_o8kynz_0(view_10));
    reactiveScope(view_10, ($this$reactiveScope) => {
      var tmp$ret$40 = !isProjectLocked($this$reactiveScope.daj(project).u7b_1);
      this_2.set(tmp$ret$40);
      return Unit_instance;
    });
    specCenteredText(view_10, buttonText);
    onClick(view_10, VOID, VOID, renderPunchListRow$slambda_4(newItems, project, lineItem));
    view_8.hbb(p_10, view_10);
    view_8.lbb(tmp_15, view_10);
    punchListCol(view_8, items, newItems, lineItem, lens, allowReorder, setTargets, buttonText, expanded);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_11 = new (Space())(view_8.pc());
    var tmp0_elvis_lhs_11 = view_8.ebb_1;
    var p_11 = tmp0_elvis_lhs_11 == null ? view_8 : tmp0_elvis_lhs_11;
    view_8.gbb(p_11, view_11);
    view_8.hbb(p_11, view_11);
    view.hbb(p_8, view_8);
    tmp_7 = view_8;
  }
  var tmp$ret$52 = tmp_7;
  view.lbb(tmp_6, tmp$ret$52);
  greySeparator(view);
  _this__u8e3s4.hbb(p, view);
}
function punchListCol(_this__u8e3s4, items, newItems, lineItem, lens, allowReorder, setTargets, buttonText, expanded) {
  allowReorder = allowReorder === VOID ? true : allowReorder;
  _init_properties_renderPunchlists_kt__f3fhf();
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_dp(0.8));
  var tmp = view.kbb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(items).i1() && $this$shownWhen.daj(newItems).i1()), view.jbb(NothingHereSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  // Inline function 'com.crowpay.views.theming.boldSubTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.lba(view_1.qb6_1.abf(SubtitleSemantic_getInstance().abf(BoldSemantic_getInstance())));
  view_1.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'Nothing Yet';
  var tmp_0 = view_1.vb5_1;
  var tmp_1;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_1 = '\xA0';
  } else {
    tmp_1 = value;
  }
  tmp_0.hbu(tmp_1);
  view_0.hbb(p_1, view_1);
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(SmallBodySemantic_getInstance()));
  view_2.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_0 = lens.zgj() ? 'Tasks will appear here once created' : 'Press "' + buttonText + '" to add a task';
  var tmp_2 = view_2.vb5_1;
  var tmp_3;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_0) === 0) {
    tmp_3 = '\xA0';
  } else {
    tmp_3 = value_0;
  }
  tmp_2.hbu(tmp_3);
  view_0.hbb(p_2, view_2);
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  renderNewPunchListItems(view, newItems, lineItem, false);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Space())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  var tmp_4 = KMutableProperty0();
  var tmp_5 = Space$_get_shown_$ref_2vywof(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp_4, tmp_5, Space$_set_shown_$ref_w6td2z(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp$ret$19 = !$this$reactiveScope.daj(newItems).i1();
    this_0.set(tmp$ret$19);
    return Unit_instance;
  });
  view.hbb(p_3, view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_4 = view.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.gbb(p_4, view_4);
  view_4.zbm(true);
  view_4.bb9(get_dp_0(8));
  var active = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.daj(items);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.q7w_1 == null) {
        destination.v(element);
      }
    }
    var tmp = destination;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_0 = punchListCol$lambda$lambda;
    // Inline function 'kotlin.comparisons.thenBy' call
    var this_0 = new (sam$kotlin_Comparator$0())(tmp_0);
    var tmp_1 = (a, b) => {
      var previousCompare = this_0.compare(a, b);
      var tmp;
      if (!(previousCompare === 0)) {
        tmp = previousCompare;
      } else {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        var tmp_0 = a.n7w_1;
        var tmp$ret$29 = b.n7w_1;
        tmp = compareValues(tmp_0, tmp$ret$29);
      }
      return tmp;
    };
    var tmp$ret$31 = new (sam$kotlin_Comparator$0())(tmp_1);
    return sortedWith(tmp, tmp$ret$31);
  });
  var groupId = Companion_getInstance_1().k2p();
  var tmp_6 = groupId.toString();
  var tmp_7 = punchListCol$slambda_0(active);
  forEachMaybeReorderableDestroying(view_4, active, tmp_6, tmp_7, allowReorder, VOID, ($this$forEachMaybeReorderableDestroying, punchItem, dragData) => {
    var view = punchListItem($this$forEachMaybeReorderableDestroying, punchItem, lens, dragData);
    var tmp;
    if (setTargets) {
      var tmp_0;
      if (!(punchItem.l7w_1 == null)) {
        var tmp_1 = JumpTo_getInstance().xg3_1;
        tmp_1.zg4(punchItem.j7w_1, view, VOID, () => {
          var tmp = get_AppScope();
          launch(tmp, VOID, VOID, punchListCol$lambda$lambda$slambda_0(expanded));
          return Unit_instance;
        });
        tmp_0 = Unit_instance;
      } else {
        var tmp_2 = JumpTo_getInstance().yg3_1;
        tmp_2.zg4(punchItem.j7w_1, view, VOID, () => {
          var tmp = get_AppScope();
          launch(tmp, VOID, VOID, punchListCol$lambda$lambda$slambda_2(expanded));
          return Unit_instance;
        });
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    return view;
  });
  view.hbb(p_4, view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Space())(view.pc());
  var tmp0_elvis_lhs_5 = view.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
  view.gbb(p_5, view_5);
  view.hbb(p_5, view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_6 = view.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.gbb(p_6, view_6);
  view_6.zbm(true);
  view_6.bb9(get_dp_0(8));
  var completed = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.daj(items);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!(element.q7w_1 == null)) {
        destination.v(element);
      }
    }
    var tmp = destination;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_0 = punchListCol$lambda$lambda_0;
    // Inline function 'kotlin.comparisons.thenByDescending' call
    var this_0 = new (sam$kotlin_Comparator$0())(tmp_0);
    var tmp_1 = (a, b) => {
      var previousCompare = this_0.compare(a, b);
      var tmp;
      if (!(previousCompare === 0)) {
        tmp = previousCompare;
      } else {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        var tmp_0 = b.n7w_1;
        var tmp$ret$44 = a.n7w_1;
        tmp = compareValues(tmp_0, tmp$ret$44);
      }
      return tmp;
    };
    // Inline function 'kotlin.comparisons.thenBy' call
    var this_1 = new (sam$kotlin_Comparator$0())(tmp_1);
    var tmp_2 = (a, b) => {
      var previousCompare = this_1.compare(a, b);
      var tmp;
      if (!(previousCompare === 0)) {
        tmp = previousCompare;
      } else {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        var tmp_0 = a.o7w_1;
        var tmp$ret$48 = b.o7w_1;
        tmp = compareValues(tmp_0, tmp$ret$48);
      }
      return tmp;
    };
    var tmp$ret$50 = new (sam$kotlin_Comparator$0())(tmp_2);
    return sortedWith(tmp, tmp$ret$50);
  });
  forEach(view_6, completed, ($this$forEach, punchItem) => {
    punchListItem($this$forEach, punchItem, lens);
    return Unit_instance;
  });
  view.hbb(p_6, view_6);
  _this__u8e3s4.hbb(p, view);
}
function punchListItem(_this__u8e3s4, value, viewType, dragData) {
  dragData = dragData === VOID ? null : dragData;
  _init_properties_renderPunchlists_kt__f3fhf();
  var tmp = Signal().hak(!(value.q7w_1 == null));
  var completed = interceptWrite(tmp, punchListItem$slambda_0(value));
  var unread = remember(VOID, VOID, VOID, ($this$remember) => isUnread_0(value, $this$remember.daj(get_session()).gfv_1));
  get_lightSection(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  var $this$row = view;
  $this$row.bb9(get_rowSpacing());
  $this$row.gba(get_rowSpacing());
  if (!(dragData == null)) {
    var tmp_0 = get_centered($this$row);
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (IconView())($this$row.pc());
    var tmp0_elvis_lhs_0 = $this$row.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? $this$row : tmp0_elvis_lhs_0;
    $this$row.gbb(p_0, view_0);
    view_0.gbu('drag');
    view_0.sbt(get_dragHandle(Companion_getInstance()));
    var tmp_1 = KMutableProperty0();
    var tmp_2 = IconView$_get_dragData_$ref_4jg2ny(view_0);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('dragData', 0, tmp_1, tmp_2, IconView$_set_dragData_$ref_k36t82(view_0));
    reactiveScope(view_0, ($this$reactiveScope) => {
      var tmp$ret$0 = dragData.hcy(VOID, VOID, new (DragShadow())($this$row, Align_Start_getInstance(), VOID, get_rem(1)));
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    $this$row.hbb(p_0, view_0);
    $this$row.lbb(tmp_0, view_0);
  }
  get_centered($this$row);
  unreadIconWhen($this$row, ($this$unreadIconWhen) => $this$unreadIconWhen.daj(unread));
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  Companion_getInstance_0();
  var tmp_3 = get_centered($this$row);
  // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Checkbox())($this$row.pc());
  var tmp0_elvis_lhs_1 = $this$row.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? $this$row : tmp0_elvis_lhs_1;
  $this$row.gbb(p_1, view_1);
  view_1.gba(get_px(0));
  var tmp_4 = view_1.qb6_1;
  // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
  Companion_getInstance_2();
  var tmp$ret$6 = new (punchListItem$$inlined$row$1())();
  view_1.lba(tmp_4.abf(tmp$ret$6));
  view_1.zah(view_1.ebk_1, completed);
  // Inline function 'com.lightningkite.kiteui.views.direct.Checkbox.enabled' call
  var value_0 = viewType.equals(ProjectLens_Contractor_getInstance());
  var tmp0 = view_1.vb5_1.bb4_1;
  // Inline function 'com.lightningkite.kiteui.views.disabled' call
  var value_1 = !value_0;
  tmp0.kb7_1.disabled = value_1;
  $this$row.hbb(p_1, view_1);
  $this$row.lbb(tmp_3, view_1);
  if (value.s7w_1 == null) {
    var tmp_5 = $this$row.kbb(get_expanding($this$row), get_centered($this$row));
    // Inline function 'kotlin.run' call
    var tmp$ret$13 = value.p7w_1 ? value.o7w_1 + ' (Required)' : value.o7w_1;
    $this$row.lbb(tmp_5, body($this$row, tmp$ret$13));
  } else {
    var tmp_6 = get_expanding($this$row);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())($this$row.pc());
    var tmp0_elvis_lhs_2 = $this$row.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? $this$row : tmp0_elvis_lhs_2;
    $this$row.gbb(p_2, view_2);
    view_2.zbm(true);
    view_2.bb9(get_dp_0(1));
    // Inline function 'kotlin.run' call
    var tmp$ret$15 = value.p7w_1 ? value.o7w_1 + ' (Required)' : value.o7w_1;
    body(view_2, tmp$ret$15);
    smallBody(view_2, 'Minor Adjustment \u2022 ' + value.s7w_1);
    $this$row.hbb(p_2, view_2);
    $this$row.lbb(tmp_6, view_2);
  }
  if (viewType.equals(ProjectLens_Contractor_getInstance()) && value.s7w_1 == null) {
    var tmp_7 = $this$row.kbb(get_centered($this$row), get_deleteButton($this$row));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Button())($this$row.pc());
    var tmp0_elvis_lhs_3 = $this$row.ebb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? $this$row : tmp0_elvis_lhs_3;
    $this$row.gbb(p_3, view_3);
    view_3.gba(get_dp_0(5));
    view_3.lbb(get_centered(view_3), get_viewIsNarrow(view_3) ? icon(view_3, resize(get_trash(Companion_getInstance()), get_rem(1)), 'delete') : body(view_3, 'Delete'));
    onClick(view_3, VOID, VOID, punchListItem$slambda_2(value));
    $this$row.hbb(p_3, view_3);
    $this$row.lbb(tmp_7, view_3);
  }
  _this__u8e3s4.hbb(p, view);
  return view;
}
function renderNewPunchListItems(_this__u8e3s4, items, lineItem, hideSave) {
  _init_properties_renderPunchlists_kt__f3fhf();
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_dp_0(8));
  shownDefaultFalse(view, ($this$shownDefaultFalse) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownDefaultFalse.daj(items).i1();
  });
  var characterLimit = 70;
  forEach(view, items, ($this$forEach, item) => {
    // Inline function 'com.lightningkite.serialization.lensPath' call
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp = serializerOrContextual(createKType(getKClass(PunchListItem()), arrayOf([]), false));
    var tmp$ret$1 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$1);
    var tmp$ret$3 = get_content(it);
    var tmp$ret$4 = lensPath(item, tmp$ret$3);
    var name = assertNotBlank(tmp$ret$4);
    var save = Action('Save', VOID, renderNewPunchListItems$lambda$slambda_0(name, item, items));
    if (get_viewIsNarrow($this$forEach)) {
      var tmp_0 = get_lightSection($this$forEach);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$forEach.pc());
      var tmp0_elvis_lhs = $this$forEach.ebb_1;
      var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
      $this$forEach.gbb(p, view);
      view.zbm(true);
      view.bb9(get_rowSpacing());
      view.gba(get_rowSpacing());
      var tmp_1 = view.kbb(view.jbb(PunchFieldSemantic_getInstance()), get_compact(view));
      // Inline function 'com.lightningkite.kiteui.views.direct.formattedTextInput' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (FormattedTextInput())(view.pc());
      var tmp0_elvis_lhs_0 = view.ebb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.gbb(p_0, view_0);
      view_0.gba(get_rem_0(0.5));
      // Inline function 'com.lightningkite.kiteui.views.direct.FormattedTextInput.hint' call
      var value = 'Name (Limit ' + characterLimit + ' Characters)';
      // Inline function 'com.lightningkite.kiteui.views.placeholder' call
      view_0.vb5_1.bb4_1.kb7_1.placeholder = value;
      var tmp_2 = renderNewPunchListItems$lambda$lambda;
      view_0.bbs(tmp_2, (it) => take(it, characterLimit));
      view_0.zah(view_0.xbr_1, name);
      view_0.obg(save);
      view.hbb(p_0, view_0);
      view.lbb(tmp_1, view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_1 = view.ebb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
      view.gbb(p_1, view_1);
      view_1.zbm(false);
      if (!hideSave) {
        var tmp_3 = view_1.kbb(get_expanding(view_1), get_compact(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(false);
        var tmp_4 = get_atTopStart(view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Checkbox())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        shownDefaultFalse(view_3, ($this$shownDefaultFalse) => {
          var tmp0_safe_receiver = lineItem;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$shownDefaultFalse.daj(tmp0_safe_receiver);
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.mfy();
          var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : newRequiredTasksAllowed(tmp2_safe_receiver);
          return tmp3_elvis_lhs == null ? true : tmp3_elvis_lhs;
        });
        // Inline function 'com.lightningkite.serialization.lensPath' call
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_5 = serializerOrContextual(createKType(getKClass(PunchListItem()), arrayOf([]), false));
        var tmp$ret$10 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$10);
        var tmp$ret$12 = get_required(it_0);
        var tmp$ret$13 = lensPath(item, tmp$ret$12);
        view_3.zah(view_3.ebk_1, tmp$ret$13);
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_4, view_3);
        var tmp_6 = view_2.kbb(get_centered(view_2), get_expanding(view_2));
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.gbb(p_4, view_4);
        view_4.lba(view_4.qb6_1.abf(BodySemantic_getInstance()));
        shownDefaultFalse(view_4, ($this$shownDefaultFalse) => {
          var tmp0_safe_receiver = lineItem;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$shownDefaultFalse.daj(tmp0_safe_receiver);
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.mfy();
          var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : newRequiredTasksAllowed(tmp2_safe_receiver);
          return tmp3_elvis_lhs == null ? true : tmp3_elvis_lhs;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value_0 = 'Required?';
        var tmp_7 = view_4.vb5_1;
        var tmp_8;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value_0) === 0) {
          tmp_8 = '\xA0';
        } else {
          tmp_8 = value_0;
        }
        tmp_7.hbu(tmp_8);
        view_2.hbb(p_4, view_4);
        view_2.lbb(tmp_6, view_4);
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp_3, view_2);
      }
      var tmp_9 = get_atEnd(view_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_5 = new (RowOrCol())(view_1.pc());
      var tmp0_elvis_lhs_5 = view_1.ebb_1;
      var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
      view_1.gbb(p_5, view_5);
      view_5.zbm(false);
      var tmp_10 = view_5.kbb(view_5.kbb(get_centered(view_5), get_textButton(view_5)), get_unpadded(view_5));
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_6 = new (Button())(view_5.pc());
      var tmp0_elvis_lhs_6 = view_5.ebb_1;
      var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
      view_5.gbb(p_6, view_6);
      view_6.lbb(get_centered(view_6), body(view_6, 'Discard'));
      onClick(view_6, VOID, VOID, renderNewPunchListItems$lambda$slambda_2(items, item));
      view_5.hbb(p_6, view_6);
      view_5.lbb(tmp_10, view_6);
      view_1.hbb(p_5, view_5);
      view_1.lbb(tmp_9, view_5);
      if (!hideSave) {
        var tmp_11 = view_1.kbb(view_1.kbb(get_centered(view_1), get_primaryButton(view_1)), get_compact(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_7 = view_1.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_1 : tmp0_elvis_lhs_7;
        view_1.gbb(p_7, view_7);
        var tmp_12 = KMutableProperty0();
        var tmp_13 = Button$_get_enabled_$ref_61t7nx_1(view_7);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_12, tmp_13, Button$_set_enabled_$ref_o8kynz_1(view_7));
        reactiveScope(view_7, ($this$reactiveScope) => {
          var tmp$ret$35 = $this$reactiveScope.daj(get_issues(name)).i1();
          this_0.set(tmp$ret$35);
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_7.pc());
        var tmp0_elvis_lhs_8 = view_7.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
        view_7.gbb(p_8, view_8);
        view_8.zbm(false);
        view_8.bb9(get_rowSpacing());
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Space())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.gbb(p_9, view_9);
        view_8.hbb(p_9, view_9);
        view_8.lbb(get_centered(view_8), body(view_8, 'Save'));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (Space())(view_8.pc());
        var tmp0_elvis_lhs_10 = view_8.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
        view_8.gbb(p_10, view_10);
        view_8.hbb(p_10, view_10);
        view_7.hbb(p_8, view_8);
        view_7.obg(save);
        view_1.hbb(p_7, view_7);
        view_1.lbb(tmp_11, view_7);
      }
      view.hbb(p_1, view_1);
      $this$forEach.hbb(p, view);
      $this$forEach.lbb(tmp_0, view);
    } else {
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_11 = new (RowOrCol())($this$forEach.pc());
      var tmp0_elvis_lhs_11 = $this$forEach.ebb_1;
      var p_11 = tmp0_elvis_lhs_11 == null ? $this$forEach : tmp0_elvis_lhs_11;
      $this$forEach.gbb(p_11, view_11);
      view_11.zbm(false);
      view_11.bb9(get_rowSpacing());
      var tmp_14 = view_11.kbb(get_expanding(view_11), get_lightSection(view_11));
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_12 = new (RowOrCol())(view_11.pc());
      var tmp0_elvis_lhs_12 = view_11.ebb_1;
      var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
      view_11.gbb(p_12, view_12);
      view_12.zbm(false);
      view_12.bb9(get_rowSpacing());
      view_12.gba(get_rowSpacing());
      if (!hideSave) {
        var tmp_15 = view_12.kbb(get_centered(view_12), get_compact(view_12));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (RowOrCol())(view_12.pc());
        var tmp0_elvis_lhs_13 = view_12.ebb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
        view_12.gbb(p_13, view_13);
        view_13.zbm(false);
        var tmp_16 = get_atTopStart(view_13);
        // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (Checkbox())(view_13.pc());
        var tmp0_elvis_lhs_14 = view_13.ebb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
        view_13.gbb(p_14, view_14);
        shownDefaultFalse(view_14, ($this$shownDefaultFalse) => {
          var tmp0_safe_receiver = lineItem;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$shownDefaultFalse.daj(tmp0_safe_receiver);
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.mfy();
          var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : newRequiredTasksAllowed(tmp2_safe_receiver);
          return tmp3_elvis_lhs == null ? true : tmp3_elvis_lhs;
        });
        // Inline function 'com.lightningkite.serialization.lensPath' call
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_17 = serializerOrContextual(createKType(getKClass(PunchListItem()), arrayOf([]), false));
        var tmp$ret$58 = isInterface(tmp_17, KSerializer()) ? tmp_17 : THROW_CCE();
        var it_1 = new (DataClassPathSelf())(tmp$ret$58);
        var tmp$ret$60 = get_required(it_1);
        var tmp$ret$61 = lensPath(item, tmp$ret$60);
        view_14.zah(view_14.ebk_1, tmp$ret$61);
        view_13.hbb(p_14, view_14);
        view_13.lbb(tmp_16, view_14);
        var tmp_18 = get_centered(view_13);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (TextView())(view_13.pc());
        var tmp0_elvis_lhs_15 = view_13.ebb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_13 : tmp0_elvis_lhs_15;
        view_13.gbb(p_15, view_15);
        view_15.lba(view_15.qb6_1.abf(BodySemantic_getInstance()));
        shownDefaultFalse(view_15, ($this$shownDefaultFalse) => {
          var tmp0_safe_receiver = lineItem;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$shownDefaultFalse.daj(tmp0_safe_receiver);
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.mfy();
          var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : newRequiredTasksAllowed(tmp2_safe_receiver);
          return tmp3_elvis_lhs == null ? true : tmp3_elvis_lhs;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value_1 = 'Required?';
        var tmp_19 = view_15.vb5_1;
        var tmp_20;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value_1) === 0) {
          tmp_20 = '\xA0';
        } else {
          tmp_20 = value_1;
        }
        tmp_19.hbu(tmp_20);
        view_13.hbb(p_15, view_15);
        view_13.lbb(tmp_18, view_15);
        view_12.hbb(p_13, view_13);
        view_12.lbb(tmp_15, view_13);
      }
      var tmp_21 = view_12.kbb(view_12.kbb(get_expanding(view_12), view_12.jbb(PunchFieldSemantic_getInstance())), get_compact(view_12));
      // Inline function 'com.lightningkite.kiteui.views.direct.formattedTextInput' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_16 = new (FormattedTextInput())(view_12.pc());
      var tmp0_elvis_lhs_16 = view_12.ebb_1;
      var p_16 = tmp0_elvis_lhs_16 == null ? view_12 : tmp0_elvis_lhs_16;
      view_12.gbb(p_16, view_16);
      view_16.gba(get_rem_0(0.5));
      // Inline function 'com.lightningkite.kiteui.views.direct.FormattedTextInput.hint' call
      var value_2 = 'Name (Limit ' + characterLimit + ' Characters)';
      // Inline function 'com.lightningkite.kiteui.views.placeholder' call
      view_16.vb5_1.bb4_1.kb7_1.placeholder = value_2;
      var tmp_22 = renderNewPunchListItems$lambda$lambda_0;
      view_16.bbs(tmp_22, (it) => take(it, characterLimit));
      view_16.zah(view_16.xbr_1, name);
      view_16.obg(save);
      view_12.hbb(p_16, view_16);
      view_12.lbb(tmp_21, view_16);
      if (!hideSave) {
        var tmp_23 = view_12.kbb(view_12.kbb(get_centered(view_12), get_primaryButton(view_12)), get_compact(view_12));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_17 = new (Button())(view_12.pc());
        var tmp0_elvis_lhs_17 = view_12.ebb_1;
        var p_17 = tmp0_elvis_lhs_17 == null ? view_12 : tmp0_elvis_lhs_17;
        view_12.gbb(p_17, view_17);
        var tmp_24 = KMutableProperty0();
        var tmp_25 = Button$_get_enabled_$ref_61t7nx_2(view_17);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('enabled', 0, tmp_24, tmp_25, Button$_set_enabled_$ref_o8kynz_2(view_17));
        reactiveScope(view_17, ($this$reactiveScope) => {
          var tmp$ret$81 = $this$reactiveScope.daj(get_issues(name)).i1();
          this_1.set(tmp$ret$81);
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_18 = new (RowOrCol())(view_17.pc());
        var tmp0_elvis_lhs_18 = view_17.ebb_1;
        var p_18 = tmp0_elvis_lhs_18 == null ? view_17 : tmp0_elvis_lhs_18;
        view_17.gbb(p_18, view_18);
        view_18.zbm(false);
        view_18.bb9(get_rowSpacing());
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_19 = new (Space())(view_18.pc());
        var tmp0_elvis_lhs_19 = view_18.ebb_1;
        var p_19 = tmp0_elvis_lhs_19 == null ? view_18 : tmp0_elvis_lhs_19;
        view_18.gbb(p_19, view_19);
        view_18.hbb(p_19, view_19);
        view_18.lbb(get_centered(view_18), body(view_18, 'Save'));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_20 = new (Space())(view_18.pc());
        var tmp0_elvis_lhs_20 = view_18.ebb_1;
        var p_20 = tmp0_elvis_lhs_20 == null ? view_18 : tmp0_elvis_lhs_20;
        view_18.gbb(p_20, view_20);
        view_18.hbb(p_20, view_20);
        view_17.hbb(p_18, view_18);
        view_17.obg(save);
        view_12.hbb(p_17, view_17);
        view_12.lbb(tmp_23, view_17);
      }
      view_11.hbb(p_12, view_12);
      view_11.lbb(tmp_14, view_12);
      var tmp_26 = view_11.kbb(view_11.kbb(get_centered(view_11), get_deleteButton(view_11)), get_compact(view_11));
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_21 = new (Button())(view_11.pc());
      var tmp0_elvis_lhs_21 = view_11.ebb_1;
      var p_21 = tmp0_elvis_lhs_21 == null ? view_11 : tmp0_elvis_lhs_21;
      view_11.gbb(p_21, view_21);
      icon(view_21, resize(get_trash(Companion_getInstance()), get_rem_0(1.25)), 'discard');
      onClick(view_21, 'Discard task', VOID, renderNewPunchListItems$lambda$slambda_4(items, item));
      view_11.hbb(p_21, view_21);
      view_11.lbb(tmp_26, view_21);
      $this$forEach.hbb(p_11, view_11);
    }
    return Unit_instance;
  });
  _this__u8e3s4.hbb(p, view);
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfv_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.whl_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = tmp_0.gf9(tmp$ret$1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return tmp_2;
}
var renderPunchListRow$slambdaClass;
function renderPunchListRow$slambda() {
  if (renderPunchListRow$slambdaClass === VOID) {
    class $ {
      constructor($items) {
        this.whl_1 = $items;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPunchListRow$slambdaClass = $;
  }
  return renderPunchListRow$slambdaClass;
}
function renderPunchListRow$slambda_0($items) {
  var i = new (renderPunchListRow$slambda())($items);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var _receiver__tnumb7 = $this.xhl_1;
  var tmp = _receiver__tnumb7.f2();
  var tmp_0 = awaitOnce($this.yhl_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_safe_receiver = $this.zhl_1;
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    var tmp_2 = awaitOnce(tmp0_safe_receiver, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_1 = tmp_2;
  }
  var tmp1_safe_receiver = tmp_1;
  _receiver__tnumb7.oam(plus(tmp, Signal().hak(new (PunchListItem())(VOID, tmp_0.v7a_1, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.mf9_1, VOID, VOID, '', false))));
  return Unit_instance;
}
var renderPunchListRow$slambdaClass_0;
function renderPunchListRow$slambda_1() {
  if (renderPunchListRow$slambdaClass_0 === VOID) {
    class $ {
      constructor($newItems, $project, $lineItem) {
        this.xhl_1 = $newItems;
        this.yhl_1 = $project;
        this.zhl_1 = $lineItem;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPunchListRow$slambdaClass_0 = $;
  }
  return renderPunchListRow$slambdaClass_0;
}
function renderPunchListRow$slambda_2($newItems, $project, $lineItem) {
  var i = new (renderPunchListRow$slambda_1())($newItems, $project, $lineItem);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var _receiver__tnumb7 = $this.ahm_1;
  var tmp = _receiver__tnumb7.f2();
  var tmp_0 = awaitOnce($this.bhm_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_safe_receiver = $this.chm_1;
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    var tmp_2 = awaitOnce(tmp0_safe_receiver, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_1 = tmp_2;
  }
  var tmp1_safe_receiver = tmp_1;
  _receiver__tnumb7.oam(plus(tmp, Signal().hak(new (PunchListItem())(VOID, tmp_0.v7a_1, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.mf9_1, VOID, VOID, '', false))));
  return Unit_instance;
}
var renderPunchListRow$slambdaClass_1;
function renderPunchListRow$slambda_3() {
  if (renderPunchListRow$slambdaClass_1 === VOID) {
    class $ {
      constructor($newItems, $project, $lineItem) {
        this.ahm_1 = $newItems;
        this.bhm_1 = $project;
        this.chm_1 = $lineItem;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPunchListRow$slambdaClass_1 = $;
  }
  return renderPunchListRow$slambdaClass_1;
}
function renderPunchListRow$slambda_4($newItems, $project, $lineItem) {
  var i = new (renderPunchListRow$slambda_3())($newItems, $project, $lineItem);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Space$_get_shown_$ref_2vywof(p0) {
  return () => p0.yb8();
}
function Space$_set_shown_$ref_w6td2z(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.dhm_1 = function_0;
      }
      wi(a, b) {
        return this.dhm_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.dhm_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function punchListCol$lambda$lambda(a, b) {
  _init_properties_renderPunchlists_kt__f3fhf();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.p7w_1;
  var tmp$ret$1 = a.p7w_1;
  return compareValues(tmp, tmp$ret$1);
}
function *_generator_invoke__zhh2q8_2($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ehm_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = reorder(it, tmp_0, tmp$ret$1.tfv_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var punchListCol$slambdaClass;
function punchListCol$slambda() {
  if (punchListCol$slambdaClass === VOID) {
    class $ {
      constructor($active) {
        this.ehm_1 = $active;
      }
      fhm(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.fhm(p1 instanceof Move() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    punchListCol$slambdaClass = $;
  }
  return punchListCol$slambdaClass;
}
function punchListCol$slambda_0($active) {
  var i = new (punchListCol$slambda())($active);
  var l = (it, $completion) => i.fhm(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $this$launch, $completion) {
  var tmp = $this.ghm_1.iah(true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var punchListCol$lambda$lambda$slambdaClass;
function punchListCol$lambda$lambda$slambda() {
  if (punchListCol$lambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($expanded) {
        this.ghm_1 = $expanded;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    punchListCol$lambda$lambda$slambdaClass = $;
  }
  return punchListCol$lambda$lambda$slambdaClass;
}
function punchListCol$lambda$lambda$slambda_0($expanded) {
  var i = new (punchListCol$lambda$lambda$slambda())($expanded);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $this$launch, $completion) {
  var tmp = $this.hhm_1.iah(true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var punchListCol$lambda$lambda$slambdaClass_0;
function punchListCol$lambda$lambda$slambda_1() {
  if (punchListCol$lambda$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($expanded) {
        this.hhm_1 = $expanded;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    punchListCol$lambda$lambda$slambdaClass_0 = $;
  }
  return punchListCol$lambda$lambda$slambdaClass_0;
}
function punchListCol$lambda$lambda$slambda_2($expanded) {
  var i = new (punchListCol$lambda$lambda$slambda_1())($expanded);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function punchListCol$lambda$lambda_0(a, b) {
  _init_properties_renderPunchlists_kt__f3fhf();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.p7w_1;
  var tmp$ret$1 = a.p7w_1;
  return compareValues(tmp, tmp$ret$1);
}
function *_generator_invoke__zhh2q8_5($this, $this$interceptWrite, checked, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'kotlin.run' call
  var $this$run = session.vfw().wfg_1;
  if (checked) {
    var tmp_0 = $this$run.tfq($this.ihm_1.j7w_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } else {
    var tmp_1 = $this$run.ufq($this.ihm_1.j7w_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return Unit_instance;
}
var punchListItem$slambdaClass;
function punchListItem$slambda() {
  if (punchListItem$slambdaClass === VOID) {
    class $ {
      constructor($value) {
        this.ihm_1 = $value;
      }
      jhm($this$interceptWrite, checked, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, $this$interceptWrite, checked), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof Signal() ? p1 : THROW_CCE();
        return this.jhm(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    punchListItem$slambdaClass = $;
  }
  return punchListItem$slambdaClass;
}
function punchListItem$slambda_0($value) {
  var i = new (punchListItem$slambda())($value);
  var l = ($this$interceptWrite, checked, $completion) => i.jhm($this$interceptWrite, checked, $completion);
  l.$arity = 2;
  return l;
}
function IconView$_get_dragData_$ref_4jg2ny(p0) {
  return () => p0.jb9();
}
function IconView$_set_dragData_$ref_k36t82(p0) {
  return (_this__u8e3s4) => {
    p0.ib9(_this__u8e3s4);
    return Unit_instance;
  };
}
var punchListItem$$inlined$row$1Class;
function punchListItem$$inlined$row$1() {
  if (punchListItem$$inlined$row$1Class === VOID) {
    class $ {
      hd1(theme) {
        return theme.wd1('chk2', VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().hfz_1.yg9_1).cb1_1;
      }
    }
    protoOf($).abf = plus_0;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    punchListItem$$inlined$row$1Class = $;
  }
  return punchListItem$$inlined$row$1Class;
}
function *_generator_invoke__zhh2q8_6($this, delete_0, $completion) {
  if (delete_0) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = tmp.tfv_1.mft($this.khm_1.j7w_1).kem($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
var punchListItem$slambda$slambdaClass;
function punchListItem$slambda$slambda() {
  if (punchListItem$slambda$slambdaClass === VOID) {
    class $ {
      constructor($value) {
        this.khm_1 = $value;
      }
      egk(delete_0, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, delete_0), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    punchListItem$slambda$slambdaClass = $;
  }
  return punchListItem$slambda$slambdaClass;
}
function punchListItem$slambda$slambda_0($value) {
  var i = new (punchListItem$slambda$slambda())($value);
  var l = (delete_0, $completion) => i.egk(delete_0, $completion);
  l.$arity = 1;
  return l;
}
var punchListItem$slambdaClass_0;
function punchListItem$slambda_1() {
  if (punchListItem$slambdaClass_0 === VOID) {
    class $ {
      constructor($value) {
        this.lhm_1 = $value;
      }
      uao($completion) {
        var tmp = get_dialogStack();
        var tmp_0 = DangerButtonSemantic_getInstance();
        tmp.zgd(new (GenericConfirmationDialog())('Delete Task?', 'This action cannot be undone.', VOID, 'Delete', VOID, tmp_0, true, VOID, VOID, VOID, punchListItem$slambda$slambda_0(this.lhm_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    punchListItem$slambdaClass_0 = $;
  }
  return punchListItem$slambdaClass_0;
}
function punchListItem$slambda_2($value) {
  var i = new (punchListItem$slambda_1())($value);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_7($this, $this$Action, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_issues($this.mhm_1);
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tmp.i1())
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.tfv_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.nhm_1;
  var tmp_2 = await_1(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$3 = tmp_2;
  var tmp_3 = tmp_1.lft(tmp$ret$3, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = modify($this.ohm_1, renderNewPunchListItems$lambda$slambda$slambda_0($this.nhm_1), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return Unit_instance;
}
var renderNewPunchListItems$lambda$slambda$slambdaClass;
function renderNewPunchListItems$lambda$slambda$slambda() {
  if (renderNewPunchListItems$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($item) {
        this.phm_1 = $item;
      }
      qhm(it, $completion) {
        return minus_0(it, this.phm_1);
      }
      s2(p1, $completion) {
        return this.qhm((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderNewPunchListItems$lambda$slambda$slambdaClass = $;
  }
  return renderNewPunchListItems$lambda$slambda$slambdaClass;
}
function renderNewPunchListItems$lambda$slambda$slambda_0($item) {
  var i = new (renderNewPunchListItems$lambda$slambda$slambda())($item);
  var l = (it, $completion) => i.qhm(it, $completion);
  l.$arity = 1;
  return l;
}
var renderNewPunchListItems$lambda$slambdaClass;
function renderNewPunchListItems$lambda$slambda() {
  if (renderNewPunchListItems$lambda$slambdaClass === VOID) {
    class $ {
      constructor($name, $item, $items) {
        this.mhm_1 = $name;
        this.nhm_1 = $item;
        this.ohm_1 = $items;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderNewPunchListItems$lambda$slambdaClass = $;
  }
  return renderNewPunchListItems$lambda$slambdaClass;
}
function renderNewPunchListItems$lambda$slambda_0($name, $item, $items) {
  var i = new (renderNewPunchListItems$lambda$slambda())($name, $item, $items);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function renderNewPunchListItems$lambda$lambda(it) {
  _init_properties_renderPunchlists_kt__f3fhf();
  return true;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  var tmp = modify($this.rhm_1, renderNewPunchListItems$lambda$slambda$slambda_2($this.shm_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var renderNewPunchListItems$lambda$slambda$slambdaClass_0;
function renderNewPunchListItems$lambda$slambda$slambda_1() {
  if (renderNewPunchListItems$lambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($item) {
        this.thm_1 = $item;
      }
      qhm(it, $completion) {
        return minus_0(it, this.thm_1);
      }
      s2(p1, $completion) {
        return this.qhm((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderNewPunchListItems$lambda$slambda$slambdaClass_0 = $;
  }
  return renderNewPunchListItems$lambda$slambda$slambdaClass_0;
}
function renderNewPunchListItems$lambda$slambda$slambda_2($item) {
  var i = new (renderNewPunchListItems$lambda$slambda$slambda_1())($item);
  var l = (it, $completion) => i.qhm(it, $completion);
  l.$arity = 1;
  return l;
}
var renderNewPunchListItems$lambda$slambdaClass_0;
function renderNewPunchListItems$lambda$slambda_1() {
  if (renderNewPunchListItems$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($items, $item) {
        this.rhm_1 = $items;
        this.shm_1 = $item;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderNewPunchListItems$lambda$slambdaClass_0 = $;
  }
  return renderNewPunchListItems$lambda$slambdaClass_0;
}
function renderNewPunchListItems$lambda$slambda_2($items, $item) {
  var i = new (renderNewPunchListItems$lambda$slambda_1())($items, $item);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function renderNewPunchListItems$lambda$lambda_0(it) {
  _init_properties_renderPunchlists_kt__f3fhf();
  return true;
}
function Button$_get_enabled_$ref_61t7nx_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  var tmp = modify($this.uhm_1, renderNewPunchListItems$lambda$slambda$slambda_4($this.vhm_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var renderNewPunchListItems$lambda$slambda$slambdaClass_1;
function renderNewPunchListItems$lambda$slambda$slambda_3() {
  if (renderNewPunchListItems$lambda$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($item) {
        this.whm_1 = $item;
      }
      qhm(it, $completion) {
        return minus_0(it, this.whm_1);
      }
      s2(p1, $completion) {
        return this.qhm((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderNewPunchListItems$lambda$slambda$slambdaClass_1 = $;
  }
  return renderNewPunchListItems$lambda$slambda$slambdaClass_1;
}
function renderNewPunchListItems$lambda$slambda$slambda_4($item) {
  var i = new (renderNewPunchListItems$lambda$slambda$slambda_3())($item);
  var l = (it, $completion) => i.qhm(it, $completion);
  l.$arity = 1;
  return l;
}
var renderNewPunchListItems$lambda$slambdaClass_1;
function renderNewPunchListItems$lambda$slambda_3() {
  if (renderNewPunchListItems$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($items, $item) {
        this.uhm_1 = $items;
        this.vhm_1 = $item;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderNewPunchListItems$lambda$slambdaClass_1 = $;
  }
  return renderNewPunchListItems$lambda$slambdaClass_1;
}
function renderNewPunchListItems$lambda$slambda_4($items, $item) {
  var i = new (renderNewPunchListItems$lambda$slambda_3())($items, $item);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var properties_initialized_renderPunchlists_kt_dahswv;
function _init_properties_renderPunchlists_kt__f3fhf() {
  if (!properties_initialized_renderPunchlists_kt_dahswv) {
    properties_initialized_renderPunchlists_kt_dahswv = true;
    rowHeight = times(get_AppDimensions().wg1_1, 2.5);
    rowSpacing = get_rem_0(0.65);
    checkboxSize = minus(get_rowHeight(), times(get_rowSpacing(), 2.5));
  }
}
//region block: exports
export {
  punchListCol as punchListCol2kgyh2t54dmzo,
  renderPunchListRow as renderPunchListRow3mo466g522loq,
};
//endregion

//# sourceMappingURL=renderPunchlists.mjs.map
